module.exports = __webpack_public_path__ + "static/media/9.e93cda53.png";